import apiClient from './api';
import { LoginRequest, RegisterRequest, AuthResponse, User, UpdateProfileRequest, UpdatePasswordRequest } from '../types';

export const authService = {
  // 로그인
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  // 회원가입
  async register(userData: RegisterRequest): Promise<AuthResponse> {
    const response = await apiClient.post<AuthResponse>('/auth/register', userData);
    return response.data;
  },

  // 프로필 조회
  async getProfile(): Promise<User> {
    const response = await apiClient.get<User>('/auth/profile');
    return response.data;
  },

  // 프로필 수정
  async updateProfile(profileData: UpdateProfileRequest): Promise<User> {
    const response = await apiClient.patch<User>('/users/profile', profileData);
    return response.data;
  },

  // 비밀번호 변경
  async updatePassword(passwordData: UpdatePasswordRequest): Promise<void> {
    await apiClient.patch('/users/profile/password', passwordData);
  },

  // 로그아웃 (클라이언트 사이드)
  logout(): void {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user');
  },

  // 토큰 저장
  setToken(token: string): void {
    localStorage.setItem('access_token', token);
  },

  // 사용자 정보 저장
  setUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
  },

  // 토큰 가져오기
  getToken(): string | null {
    return localStorage.getItem('access_token');
  },

  // 사용자 정보 가져오기
  getUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // 로그인 상태 확인
  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;
    
    // 토큰 만료 시간 확인 (JWT 토큰의 경우)
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      
      // 토큰이 만료되었으면 제거
      if (payload.exp && payload.exp < currentTime) {
        this.logout();
        return false;
      }
      
      return true;
    } catch (error) {
      // 토큰 파싱 실패 시 제거
      this.logout();
      return false;
    }
  },

  // 관리자 권한 확인
  isAdmin(): boolean {
    const user = this.getUser();
    return user?.role === 'ADMIN';
  },
}; 